import { defineFormConfig } from "@src/components/business-form";
import type { StorePlacePlaceSdbParams } from "../../../../../../api/storePlaces";

/**
 * Значения формы размещения продукции по строке ВЗН УП.
 *
 * Количество здесь не хранится: по контракту приемки СГП размещается весь остаток строки,
 * поэтому оно вычисляется из состава ВЗН УП и остаётся производной от серверных данных.
 */
export interface StockFinishedGoodsReceiptContentFormValues {
    /** Код выбранной ячейки размещения. */
    cellCode: number | null;
}

/** Конфигурация формы размещения продукции по строке ВЗН УП. */
export const stockFinishedGoodsReceiptContentFormConfig = defineFormConfig<
    StockFinishedGoodsReceiptContentFormValues,
    StorePlacePlaceSdbParams
>({
    fields: {
        cellCode: {
            type: "number",
            nullable: true,
            label: "Ячейка размещения",
            validation: { required: true },
            map: "cellCode",
        },
    },
});
